import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import exhibit from './pages/exhibit';
import about from './pages/about';

const theme = createTheme({
	palette: {
		background: {
			default: '#000200'
		},
		color: {
			default: '#c6bfc7'
		},
		primary: {
			light: '#ce93d8',
			main: '#ffeb3b',
			dark: '#968847',
			contrastText: '#FFFFFF'
		},
		secondary:{
			main: '#968847',
			light: '#ce93d8',
		},
		text: {
			primary: '#EEEEEE',
			secondary: '#c6bfc7',
			standard: '#ffeb3b'
		}
	},
	typography: {
		fontFamily: [
			"Futura",
			'Apple Gothic', 
			'Courier',
			'Century Gothic', 
			'Corbel', 
			"Futura", 
			"Futura Md", 
			"Helvetica Neue", 
			'Roboto',
			"Verdana", 
			"sans-serif"			
		].join(','),
	},
});

function App() {
	return (
		<MuiThemeProvider theme={theme}>
			<Router>
					<div>
						<Switch>
								<Route exact path="/about" component={about}/>
								<Route path="/" component={exhibit} />
						</Switch>
					</div>
			</Router>
		</MuiThemeProvider>
	);
}

export default App;
